import React from 'react';
import { CreditCard, ShieldCheck, Wallet, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { insuranceProviders, paymentOptions } from '../data/mock';

const iconMap = {
  Insurance: ShieldCheck,
  'Flexible Financing': CreditCard,
  'FSA/HSA': Wallet,
  'Family Discounts': Users,
};

const Insurance = () => {
  return (
    <section className="py-24 gradient-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-teal-50 text-teal-700 font-semibold text-sm rounded-full mb-4">
            Insurance & Payment
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-6">
            Flexible Payment
            <span className="text-gradient"> Options</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            We believe everyone deserves a beautiful smile. That's why we offer 
            multiple payment options to fit your budget.
          </p>
        </div>

        {/* Payment Options Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {paymentOptions.map((option, index) => {
            const IconComponent = iconMap[option.title] || CreditCard;
            return (
              <Card
                key={option.title}
                className={`border-0 shadow-lg hover:shadow-xl card-hover bg-white text-center animate-fade-in-up`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardContent className="p-6">
                  <div className="service-icon w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="w-7 h-7 text-teal-600" />
                  </div>
                  <h3 className="font-bold text-slate-800 mb-2">{option.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {option.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Insurance Providers */}
        <div className="bg-white rounded-3xl shadow-lg p-8 lg:p-12">
          <div className="text-center mb-10">
            <h3 className="text-2xl font-bold text-slate-800 mb-3">
              We Accept Most Major Insurance Plans
            </h3>
            <p className="text-slate-600">
              Don't see your insurance? Contact us – we work with many more providers!
            </p>
          </div>

          {/* Insurance logos grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {insuranceProviders.map((provider, index) => (
              <div
                key={provider}
                className="flex items-center justify-center p-4 bg-slate-50 rounded-xl hover:bg-teal-50 transition-colors duration-200 animate-fade-in"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <span className="font-semibold text-slate-700">{provider}</span>
              </div>
            ))}
          </div>

          {/* Free consultation CTA */}
          <div className="mt-10 text-center">
            <p className="text-slate-600 mb-4">
              Not sure about your coverage? We'll help you understand your benefits.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors"
            >
              Contact us for a benefits check →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Insurance;
